import api from "./configAxios";

export const fetchAuditLogs = async (params) => {
  try {
    const queryParams = new URLSearchParams();
    
    // Add pagination parameters
    if (params.page) queryParams.append('Page', params.page);
    if (params.pageSize) queryParams.append('PageSize', params.pageSize);
    
    // Add filter parameters
    if (params.from) queryParams.append('From', params.from);
    if (params.to) queryParams.append('To', params.to);
    if (params.eventCategory) queryParams.append('EventCategory', params.eventCategory);
    if (params.eventType) queryParams.append('EventType', params.eventType);
    if (params.eventName) queryParams.append('EventName', params.eventName);
    if (params.platform) queryParams.append('Platform', params.platform);
    if (params.outcome) queryParams.append('Outcome', params.outcome);
    if (params.userId) queryParams.append('UserId', params.userId);
    if (params.userRole !== undefined) queryParams.append('UserRole', params.userRole);
    if (params.Email) queryParams.append('Email', params.Email);
    if (params.contextContainsJson) queryParams.append('ContextContainsJson', params.contextContainsJson);
    if (params.sort) queryParams.append('Sort', params.sort);

    const response = await api.get(`/api/api/Audit?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    throw error;
  }
};
